import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Divider,
  Toolbar,
  IconButton,
  AppBar,
  Container,
  OutlinedInput,
  Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { ReactComponent as Back } from 'Images/icons/ic_details_edit_back.svg';
import PropTypes from 'prop-types';
import {
  PAGE_ACTIONS,
  validEmailRegex,
  nameRegex,
  lettersRegex,
  USER_ROLES,
} from 'Utils/constants';
import { setUserCurrentAction } from 'Actions/users';
import { getUserInfo, updateUser, createUser } from 'Actions/userViews';
import { ReactComponent as CheckedIcon } from 'Images/icons/ic_details_edit_filled_field_tick.svg';

const styles = theme => ({
  appBar: {
    backgroundColor: '#ffffff',
  },
  container: {
    padding: '0 40px 0 40px',
    height: '100%',
  },
  backButton: {
    paddingLeft: 30,
  },
  inputField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: '#fbfbfc',
    maxHeight: '44px',
    width: '100%',
  },
  root: {
    flexWrap: 'wrap',
  },
  labelMargin: {
    fontSize: 14,
    marginTop: 32,
  },
  flexGrow: {
    flexGrow: 1,
    flexDirection: 'row',
  },
  submitButton: {
    width: '100%',
    borderRadius: 6,
    backgroundColor: '#000000',
    color: 'white',
  },
  fieldTitle: {
    fontSize: 14,
    marginTop: 15,
  },
  stickToBottom: {
    bottom: '20px',
    top: 'auto',
    right: 'auto',
    position: 'fixed',
    width: '368px',
  },
  validIcon: {
    width: '26px',
  },
});

const intialState = {
  name: '',
  designation: '',
  userId: '',
  access: USER_ROLES.HR_PARTNER,
  email: '',
  isActive: true,
};

class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      designation: this.props.designation,
      userId: this.props.userId,
      access: this.props.access,
      email: this.props.email,
      isActive: this.props.isActive,
      errors: {
        name: '',
        designation: '',
        email: '',
      },
    };
    this.handleValue = this.handleValue.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { edit, userId } = this.props;
    if (edit) {
      this.props.getUserInfo(userId);
    } else {
      this.setState(intialState);
    }
  }

  handleBack() {
    this.props.setUserCurrentAction(PAGE_ACTIONS.VIEW);
  }

  validateForm(keys) {
    let valid = true;
    const { name, designation, email, errors } = this.state;
    keys.forEach(validateField);
    function validateField(value) {
      switch (value) {
        case 'name':
          errors.name =
            !name || name.trim().length === 0 ? 'Name is required' : '';
          if (!errors.name) {
            errors.name = nameRegex.test(name) ? '' : 'Name is not valid!';
          }
          break;
        case 'designation':
          errors.designation =
            !designation || designation.trim().length === 0
              ? 'Designation is required'
              : '';
          if (!errors.designation) {
            errors.designation = lettersRegex.test(designation)
              ? ''
              : 'Designation is not valid!';
          }
          break;
        case 'email':
          errors.email =
            !email || email.trim().length === 0 ? 'Email is required' : '';
          if (!errors.email) {
            errors.email = validEmailRegex.test(email)
              ? ''
              : 'Email is not valid!';
          }
          break;
        default:
          break;
      }
    }
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      val => val.length > 0 && (valid = false)
    );
    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    const { edit, accountId } = this.props;
    const { errors } = this.state;
    if (this.validateForm(Object.keys(errors))) {
      if (edit) {
        this.props.updateUser({
          ...this.state,
          accountId: accountId,
        });
      } else {
        this.props.createUser({
          ...this.state,
          accountId: accountId,
        });
      }
    } else {
      console.error('Invalid Form');
    }
  }

  handleValue = key => event => {
    this.setState({ [key]: event.target.value }, () => {
      this.validateForm([key]);
    });
  };

  render() {
    const { classes, edit } = this.props;
    const { name, designation, access, email, isActive, errors } = this.state;

    return (
      <div>
        <AppBar position="static" elevation={0} className={classes.appBar}>
          <Toolbar variant="dense">
            <IconButton onClick={this.handleBack}>
              <Back />
            </IconButton>
            <Typography variant="body1" color="textPrimary">
              {edit ? 'EDIT USER DETAILS' : 'CREATE A USER'}
            </Typography>
            <div className={classes.root} />
          </Toolbar>
        </AppBar>
        <Divider />
        <Container className={classes.container}>
          <form className={classes.root} autoComplete="off">
            <InputLabel color="textPrimary" className={classes.labelMargin}>
              User Full Name
            </InputLabel>
            <OutlinedInput
              fullWidth
              className={classes.inputField}
              value={name}
              onChange={this.handleValue('name')}
              id="name"
            />
            {errors.name.length > 0 && (
              <span className="error">{errors.name}</span>
            )}
            <InputLabel color="textPrimary" className={classes.fieldTitle}>
              Designation
            </InputLabel>
            <OutlinedInput
              fullWidth
              className={classes.inputField}
              value={designation}
              onChange={this.handleValue('designation')}
              id="designation"
            />
            {errors.designation.length > 0 && (
              <span className="error">{errors.designation}</span>
            )}
            <InputLabel color="textPrimary" className={classes.fieldTitle}>
              Access Type
            </InputLabel>
            <Select
              onChange={this.handleValue('access')}
              input={<OutlinedInput fullWidth name="access" id="access" />}
              value={access}
              className={classes.inputField}
            >
              <MenuItem value={USER_ROLES.HR_PARTNER}> HR Partner </MenuItem>
              <MenuItem value={USER_ROLES.HR_ADMIN}> HR Admin </MenuItem>
            </Select>
            <InputLabel color="textPrimary" className={classes.fieldTitle}>
              Email Id
            </InputLabel>
            <OutlinedInput
              fullWidth
              className={classes.inputField}
              value={email}
              disabled={edit}
              onChange={this.handleValue('email')}
              endAdornment={
                errors.email.length > 0 || !email ? null : (
                  <CheckedIcon className={classes.validIcon} />
                )
              }
              id="emailId"
            />
            {errors.email.length > 0 && (
              <span className="error">{errors.email}</span>
            )}
            <InputLabel color="textPrimary" className={classes.fieldTitle}>
              Status
            </InputLabel>
            <Select
              onChange={this.handleValue('isActive')}
              input={<OutlinedInput fullWidth name="status" id="status" />}
              className={classes.inputField}
              value={isActive}
            >
              <MenuItem value> Active </MenuItem>
              <MenuItem value={false}> Disable </MenuItem>
            </Select>
            <Grid
              container
              justify="space-between"
              className={classes.stickToBottom}
            >
              <Button
                variant="contained"
                className={classes.submitButton}
                onClick={this.handleSubmit}
              >
                {edit ? 'UPDATE DETAILS' : 'CREATE USER'}
              </Button>
            </Grid>
          </form>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setUserCurrentAction,
  getUserInfo,
  createUser,
  updateUser,
};

const mapStateToProps = state => {
  return {
    ...state.userViews,
    userId: state.users.currentSelection,
    accountId: state.authUser.accountId,
  };
};

AddUser.defaultProps = intialState;

AddUser.propTypes = {
  classes: PropTypes.object.isRequired,
  accountId: PropTypes.string.isRequired,
  edit: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  access: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  setUserCurrentAction: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  createUser: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
};

AddUser = compose(withStyles(styles, { withTheme: true }))(AddUser);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUser);
